import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/crm-para-corretora-de-seguros")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["crm-para-corretora-de-seguros"]!.metaTitle,
    description: SEGMENT_BY_SLUG["crm-para-corretora-de-seguros"]!.metaDescription,
    path: "/crm-para-corretora-de-seguros",
  }),
  component: () => <SegmentRoute slug="crm-para-corretora-de-seguros" />,
});
